/**
 * .popup-banner-component
 */

function init ()
{
    $('.component-popup-banner').each(function () {

        const jqBanner = $(this);
        const jqClose = jqBanner.find('.btn-close');
        const jqImg = jqBanner.find('img');
        var bottomWhenHide;
        var delay = 3000; // ms
        var transDuration = 300; // ms (CSS must have that or less)

        jqBanner.css({display: 'block'});
        bottomWhenHide = -jqBanner.height();
        jqBanner.css({display: 'none', bottom: bottomWhenHide});

        /* First display block, then set bottom. If set at once, transition set
         * in CSS has no effect. */
        setTimeout(() => {
            jqBanner.css({display: 'block'});
        }, delay - 50);
        setTimeout(() => {
            jqBanner.css({bottom: 0});
        }, delay);

        jqClose.on('click', function () {
            jqClose.hide();
            jqBanner.css({bottom: bottomWhenHide});
            setTimeout(function () {
                jqBanner.remove();
            }, transDuration);
        });

    });

}

export default {
    init,
};
